import { Dropdown } from '@/shared/ui/Dropdown/Dropdown';
import { cva } from 'class-variance-authority';
import { Form, Formik } from 'formik';
import { FC } from 'react';
import { twMerge } from 'tailwind-merge';
import { ReviewsFilter } from '@/features/product-reviews/ui/ProductReviews';

interface Props {
  className?: string;
  values: ReviewsFilter;
  onChange?: (values: ReviewsFilter) => void;
}

const sorts = [
  {
    id: 0,
    value: 'desc',
    label: 'Сначала новые',
  },
  {
    id: 1,
    value: 'asc',
    label: 'Сначала старые',
  },
];

export const Filters: FC<Props> = ({ className, values, onChange }) => {
  return (
    <Formik
      initialValues={values}
      onSubmit={({ sort }) => {
        onChange?.({ ...values, sort });
      }}
      enableReinitialize
    >
      {({ getFieldProps, submitForm }) => (
        <Form className={twMerge(cvaRoot(), className)} autoComplete="off">
          <div></div>
          <div>
            <Dropdown
              name={'sort'}
              place={'right'}
              data={sorts}
              placeholder="Сортировка"
              value={getFieldProps('sort').value}
              multiselect={false}
              onChange={submitForm}
            />
          </div>
        </Form>
      )}
    </Formik>
  );
};

const cvaRoot = cva(['Filters-cvaRoot', ' ']);
